module.exports = __webpack_public_path__ + "static/media/fast.c454f12d.svg";